export const MARKET_TRENDS_SECTION_ID = 'market-trends-section';
export const MARKET_TRENDS_SECTION_TITLE = 'Market trends';

export const OFFER_TYPES_SECTION_ID = 'offer-types-section';
export const OFFER_TYPES_SECTION_TITLE = 'Offer types';

export const COMPARABLES_SECTION_ID = 'comparables-section';
export const COMPARABLES_SECTION_TITLE = 'Comparables';

export const MLS_INFO_SECTION_ID = 'mls-info-section';
export const MLS_INFO_SECTION_TITLE = 'MLS info';

export const SECTIONS = [
  {
    id: MARKET_TRENDS_SECTION_ID,
    label: MARKET_TRENDS_SECTION_TITLE,
  },
  {
    id: OFFER_TYPES_SECTION_ID,
    label: OFFER_TYPES_SECTION_TITLE,
  },
  {
    id: COMPARABLES_SECTION_ID,
    label: COMPARABLES_SECTION_TITLE,
  },
  {
    id: MLS_INFO_SECTION_ID,
    label: MLS_INFO_SECTION_TITLE,
  },
];
